import { SVGProps } from 'react';

const Crop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 2v14a2 2 0 0 0 2 2h14m-4 4V8a2 2 0 0 0-2-2H2"
    />
  </svg>
);
export default Crop;
